import { cn } from "@/lib/utils";
import { Trophy, Medal, Award } from "lucide-react";

const rankIcons = {
  1: { icon: Trophy, color: 'text-soft-amber' },
  2: { icon: Medal, color: 'text-soft-silver' },
  3: { icon: Award, color: 'text-soft-amber/60' },
};

export const LeaderboardCard = ({ 
  rank, 
  name, 
  subtitle,
  value,
  valueLabel,
  avatar,
  className 
}) => {
  const rankConfig = rankIcons[rank];
  const RankIcon = rankConfig?.icon;
  
  return (
    <div 
      className={cn(
        "flex items-center gap-4 bg-graphite rounded-xl border border-white/[0.06] p-4",
        "transition-all duration-200 hover:border-white/[0.12]",
        rank === 1 && "border-soft-amber/30 bg-gradient-to-r from-soft-amber/5 to-transparent",
        className
      )}
      data-testid="leaderboard-card"
    >
      {/* Rank */}
      <div className={cn(
        "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0",
        rank <= 3 ? "bg-white/[0.08]" : "bg-white/[0.05]"
      )}>
        {RankIcon ? (
          <RankIcon className={cn("w-5 h-5", rankConfig.color)} />
        ) : (
          <span className="text-lg font-bold font-mono text-muted-text">
            {rank}
          </span>
        )}
      </div>
      
      {/* Avatar */}
      {avatar && (
        <div className="w-10 h-10 rounded-full bg-obsidian border border-white/[0.06] overflow-hidden flex-shrink-0">
          <img src={avatar} alt={name} className="w-full h-full object-cover" />
        </div>
      )}
      
      {/* Info */}
      <div className="flex-1 min-w-0">
        <h4 className="text-cloud-white font-medium truncate">{name}</h4>
        {subtitle && (
          <p className="text-sm text-muted-text truncate">{subtitle}</p>
        )}
      </div>
      
      {/* Value */}
      <div className="text-right flex-shrink-0">
        <span className="text-xl font-semibold font-mono text-cloud-white">
          {value}
        </span>
        {valueLabel && (
          <p className="text-xs text-muted-text">{valueLabel}</p>
        )}
      </div>
    </div>
  );
};

export const LeaderboardList = ({ 
  items = [], 
  title,
  className 
}) => {
  return (
    <div className={cn("space-y-3", className)} data-testid="leaderboard-list">
      {title && (
        <h3 className="text-lg font-medium text-cloud-white mb-4">{title}</h3>
      )}
      {items.map((item, index) => (
        <LeaderboardCard key={index} rank={index + 1} {...item} />
      ))}
    </div>
  );
};

export default LeaderboardCard;
